import {StringValidacao} from './string';
import {Construtor} from './construtor';

export class TipoPontoFisico implements Construtor<TipoPontoFisico> {
  public idTipoPontoFisico: number;
  public idCliente: number;
  public descricaoTipoPontoFisico: string;

  constructor(object?: any) {

    if (object !== undefined) {

      if (object instanceof TipoPontoFisico) {
        this.copyObject(object);
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }

    }

    return this;
  }

  get obterIdTipoPontoFisico(): number {
    return this.idTipoPontoFisico;
  }

  set IdTipoPontoFisico(idTipoPontoFisico: any) {
    this.idTipoPontoFisico = idTipoPontoFisico;
  }

  get obterDescricaoTipoPontoFisico(): string {
    return this.descricaoTipoPontoFisico;
  }

  set DescricaoTipoPontoFisico(descricaoTipoPontoFisico) {
    this.descricaoTipoPontoFisico = StringValidacao.copiarStringValida(descricaoTipoPontoFisico);
  }

  copyObject(tipoPontoFisico: TipoPontoFisico): void {
    this.idTipoPontoFisico = tipoPontoFisico.idTipoPontoFisico;
    this.idCliente = tipoPontoFisico.idCliente;
    this.descricaoTipoPontoFisico = tipoPontoFisico.descricaoTipoPontoFisico;
  }

  parseFromJson(tipoPontoFisico: any): void {
    this.idTipoPontoFisico = tipoPontoFisico.idTipoPontoFisico;
    this.idCliente = tipoPontoFisico.idCliente;
    this.descricaoTipoPontoFisico = tipoPontoFisico.descricaoTipoPontoFisico;
  }

  modeloCompleto(): boolean {
    return this.descricaoTipoPontoFisico !== undefined;
  }

  getNewInstance(object?: any): TipoPontoFisico {
    return new TipoPontoFisico(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/tipo-ponto-fisico.ts